import axiosInterceptor from 'services/axiosInterceptor'
import { API_BASE_URL } from 'services/constants'

import type { NotificationItem, NotificationPage } from '../types/notification.types'

/** The signed-in user's notifications (MYD-542), from /api/notifications (MYD-540). */

const api = () => axiosInterceptor(API_BASE_URL)

export const PAGE_SIZE = 20

/** A page, newest first. `before` is the previous page's `nextCursor`. */
export async function listNotifications(before?: string | null): Promise<NotificationPage> {
	const { data } = await api().get<NotificationPage>('/notifications', {
		params: { limit: PAGE_SIZE, ...(before ? { before } : {}) },
	})
	return data
}

/** The cheap call the bell polls. */
export async function getUnreadCount(): Promise<number> {
	const { data } = await api().get<{ count: number }>('/notifications/unread-count')
	return data.count
}

export async function markNotificationRead(id: string, read = true): Promise<NotificationItem> {
	const { data } = await api().patch<NotificationItem>(`/notifications/${id}`, { read })
	return data
}

export async function markAllNotificationsRead(): Promise<number> {
	const { data } = await api().post<{ updated: number }>('/notifications/read-all')
	return data.updated
}
